import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { RingIcon } from "../libs/SVGIcons";
import { database } from "../libs/estrylib/Firebase";
import { Link } from "react-router-dom";
import friendlyTime from "friendly-time";
import createActivityDetector from "activity-detector";
import axios from "../axios";
import { logoutUser, showMessage, handleAppError } from "../actions";
import toast, { Toaster } from "react-hot-toast";
import { ITQModal } from "./ITQModal";
import { Button } from "@material-ui/core";
import { High, Low } from "./AnnouncementPriorities";
import { NotificationsFirebaseKey } from "./FirebaseKeys";
import AppConfig from "../constants/AppConfig";
// import InactivityTimer from 'inactivity-timer';

class ITQNotifications extends Component {
  state = {
    notifications: [],
    highPriorityNotifications: [],
    isNotify: false,
    showImportantNoteModal: false,
    notificationItem: null,
    showRedNum: false,
  };
  firebaseRef = null;
  ref = null;
  btn = null;
  img =
    "https://media.istockphoto.com/photos/beautiful-woman-blonde-hair-portrait-close-up-studio-on-white-picture-id498894204?k=20&m=498894204&s=612x612&w=0&h=yXPpUEyz27_Q-xqcypuRa3n5VdsF6tNvKKwyYUhCBLA=";
  newItems = false;
  activityDetector = null;
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.btn = React.createRef();
    this.firebaseRef = database
      .ref()
      .child(NotificationsFirebaseKey)
      .endAt()
      .limitToLast(1);


  }
  async handler() {
    const { handleAppError } = this.props;
    try {
      const { isNotify, showRedNum } = this.state;
      if (showRedNum) {
        if (isNotify) {
          await this.setState({
            isNotify: false,
          });
        } else {
          await this.setState({
            isNotify: true,
          });
        }
        await axios.post("/notifications/set-latest-low-as-seen");
        await this.setState({
          showRedNum: false,
        });
      }
    } catch (error) {
      handleAppError(error);
    }
  }
  logoutIfInactive() {
    const { max_inactivity_duration, user_id, is_root_agency } =
      this.props.user;
    this.activityDetector = createActivityDetector({
      timeToIdle: parseInt(max_inactivity_duration),
      inactivityEvents: [""],
      autoInit: false,
    });
    const isRootAgency = is_root_agency;
    if (user_id) {
      if (!isRootAgency) {
        // const obj = this;
        // this.activityDetector.on("idle", function () {
        //   obj.props.logoutUser();
        // });
        // this.activityDetector.init();
      }
      const timer = window.setInterval(function () {
        if (
          !localStorage.getItem("esitqapp-agency-id") &&
          !localStorage.getItem("esitqapp-nocheck")
        ) {
          window.clearInterval(timer);
          window.location.reload();
        }
      }, 100);
    }
  }
  componentDidMount() {
    const { isNotify } = this.state;
    const { lang } = this.props.user;
    document.addEventListener("click", (e) => {
      if (!isNotify) {
        if (this.ref.current) {
          let isClick = this.ref.current.contains(e.target),
            isBtn = this.btn.current.contains(e.target);
          if (!isClick && !isBtn) {
            this.setState({
              isNotify: false,
            });
          }
        }
      }
    });
    const cpt = this;
    this.firebaseRef.on("child_added", (snapshot) => {
      console.log("child added ...");
      if (cpt.newItems) {
        const notifications = [...this.state.notifications],
          { userId, agencyId } = this.props,
          notification = snapshot.val(),
          notificationItem = {
            id: notification.id,
            text: notification.text,
            time: notification.time,
          };

        // if (notification.seenby && notification.includes(userId)) {
        //   return;
        // }
        if (notification.toagencyid && notification.toagencyid === agencyId) {
          if (notification.priority === Low) {
            toast(window.sys_app_translate(notification.text, lang), {
              duration: 5000,
            });
            notifications.unshift(notificationItem);
            this.setState({
              notifications: notifications,
              time: notification.time,
              showRedNum: true,
            });
          } else {
            this.setState({
              notificationItem: notification,
              showImportantNoteModal: true,
            });
          }
          return;
        }
        if (notification.touserid && notification.touserid === userId) {
          if (notification.priority === Low) {
            toast(window.sys_app_translate(notification.text, lang), {
              duration: 5000,
            });
            notifications.unshift(notificationItem);
            this.setState({
              notifications: notifications,
              time: notification.time,
              showRedNum: true,
            });
          } else {
            this.setState({
              notificationItem: notification,
              showImportantNoteModal: true,
            });
          }
          return;
        }
        if (!notification.touserid && !notification.toagencyid) {
          if (notification.priority === Low) {
            toast(window.sys_app_translate(notification.text, lang), {
              duration: 5000,
            });
            notifications.unshift(notificationItem);
            this.setState({
              notifications: notifications,
              showRedNum: true,
              time: notification.time,
            });
          } else {
            this.setState({
              notificationItem: notification,
              showImportantNoteModal: true,
            });
          }
          return;
        }
      }
    });
    this.firebaseRef.once("value", function (snapshot) {
      console.log("once value ...");
      cpt.newItems = true;
    });
    this.logoutIfInactive();
    if (this.props.user.lang === "ar" || this.props.user.lang === "fa") {
      document.documentElement.setAttribute("lang", "ar");
      document.documentElement.setAttribute("dir", "rtl");
      var link = document.getElementById("btcss");
      link.setAttribute("href", "/bootstrap-ar.css");
      document.body.dir = "rtl";
    }
    this.getNotifications(High).then(() => {
      this.getNotifications(Low);
    });
    // const inactivityTimer = InactivityTimer('0m', () => {
    //   console.log("User is inactive, logging out...");
    //   this.props.logoutUser();
    // });
    // document.addEventListener("mousemove", () => {
    //   console.log("User is active, resetting inactivity timer...");
    //   inactivityTimer.signal();
    // });
  }
  componentWillUnmount() {
    if (this.activityDetector) {
      this.activityDetector.stop();
    }
  }
  calculateElapsedTime(time) {
    const date = new Date(time);
    return friendlyTime(date);
  }
  decideLink(text) {
    if (text.includes("Insurance")) {
      return "/app/insurance-requests/view-all";
    }
    if (text.includes("Balance")) {
      return "/app/balance-requests/view-all";
    }
    return null;
  }
  getImportantNoteModal() {
    const { showImportantNoteModal, notificationItem } = this.state;
    const { lang } = this.props.user;
    return (
      showImportantNoteModal && (
        <ITQModal
          isOpen={showImportantNoteModal}
          isCenterd={true}
          cancelButtonText="x"
          cancelButtonClicked={async () => {
            await this.setNotificationAsSeen(notificationItem.id);
            await this.setState({
              showImportantNoteModal: false,
            });
          }}
          title={window.sys_app_translate("Notification", lang)}
          bodyContent={
            <>
              {notificationItem.link && notificationItem.image && (
                <div className="row justify-content-center">
                  <div className="col-8 text-center">
                    <a href={notificationItem.link}>
                      <img
                        src={AppConfig.storagePath + notificationItem.image}
                        style={{ height: "400px" }}
                      />
                    </a>
                  </div>
                </div>
              )}
              {!notificationItem.link && notificationItem.image && (
                <div className="row justify-content-center">
                  <div className="col-8 text-center">
                    <img
                      src={AppConfig.storagePath + notificationItem.image}
                      style={{ height: "400px" }}
                    />
                  </div>
                </div>
              )}
              <div
                className="row justify-content-center"
                style={{ marginTop: "1rem" }}
              >
                <div
                  className="col-8 text-center"
                  style={{ fontSize: "1.2rem" }}
                >
                  {notificationItem.text}
                </div>
              </div>
              {notificationItem.link && (
                <div
                  className="row justify-content-center"
                  style={{ marginTop: "1rem" }}
                >
                  <div className="col-8 text-center">
                    <a href={notificationItem.link}>
                      {window.sys_app_translate("Click Here", lang)}
                    </a>
                  </div>
                </div>
              )}
              <div
                className="row justify-content-center"
                style={{ marginTop: "1rem" }}
              >
                <div className="col-8 text-center">
                  <Button
                    variant="contained"
                    style={{ display: "inline" }}
                    className="table-add-button estry-accept-button inter inter-bold"
                    onClick={async () => {
                      console.log("confirming notification ...");
                      await this.setNotificationAsSeen(notificationItem.id);
                      await this.setState({
                        showImportantNoteModal: false,
                      });
                    }}
                  >
                    {window.sys_app_translate("Confirm", lang)}
                  </Button>
                </div>
              </div>
            </>
          }
          size="lg"
        />
      )
    );
  }
  async setNotificationAsSeen(notificationId) {
    const { handleAppError } = this.props;
    try {
      await axios.post("/notifications/set-as-seen/" + notificationId);
    } catch (error) {
      handleAppError(error);
    }
  }
  async getNotifications(priority) {
    const { handleAppError } = this.props;
    console.log("getting " + priority + " notifications ...");
    try {
      const response = await axios.get("/notifications/get-for-dropdown", {
        params: {
          priority: priority,
        },
      });
      const nots = [];
      switch (priority) {
        case Low:
          const data = response.data.data.Low;
          await this.setState({
            notifications: nots.concat(data.system, data.agency, data.user),
            showRedNum: true,
          });
          break;
        case High:
          const data2 = response.data.data.High;
          if (
            data2.agency.length > 0 ||
            data2.system.length > 0 ||
            data2.user.length > 0
          ) {
            await this.setState({
              highPriorityNotifications: nots.concat(
                data2.system,
                data2.agency,
                data2.user
              ),
            });
            await this.setState({
              notificationItem: this.state.highPriorityNotifications[0],
              showImportantNoteModal: true,
            });
          }

          break;
      }
    } catch (error) {
      handleAppError(error);
    }
  }
  render() {
    const { notifications, isNotify, showRedNum } = this.state;
    const { lang, history } = this.props;
    return (
      <div className="notify">
        {this.getImportantNoteModal()}
        <Toaster position="bottom-center" reverseOrder={false} />
        <div className="container">
          <button
            ref={this.btn}
            onClick={this.handler.bind(this)}
            className="notify-btn"
          >
            <span
              style={{ display: "inline-block" }}
              className={
                notifications.length > 0
                  ? "img animate__animated animate__headShake animate__delay-2s"
                  : "img "
              }
            >
              {<RingIcon />}
            </span>
            {notifications.length > 0 && showRedNum && (
              <span className="num">{notifications.length}</span>
            )}
          </button>
          <div
            ref={this.ref}
            className={`notify-card-wrp ${(isNotify && " active") || ""}`}
          >
            <div className="notify-card">
              <div className="notify-card-intigator"></div>
              <div className="notify-card-head">
                <h3>{window.sys_app_translate("Notifications", lang)}</h3>
                <Link to="/">{window.sys_app_translate("View All", lang)}</Link>
              </div>
              <ul className="notify-card-notification px-0">
                {notifications.map((notification, i) => (
                  <li key={i} className="notify-card-notification-item">
                    {/* <div className="notify-card-notification-item-img">
                      <img src={this.img} alt="" />
                    </div> */}
                    <div
                      className="notify-card-notification-item-text"
                      style={{ marginLeft: "10px" }}
                    >
                      <Link to={this.decideLink(notification.text)}>
                        <h2
                          className="inter inter-medium"
                          style={{ fontSize: "16px" }}
                        >
                          {window.sys_app_translate(notification.text, lang)}
                        </h2>
                      </Link>
                      <span>
                        {this.calculateElapsedTime(notification.time)}
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// map state to props
const mapStateToProps = ({ settings, authUser, appReducer }) => {
  const { loading } = appReducer;
  const { user } = authUser;
  return { user, loading };
};

export default withRouter(
  connect(mapStateToProps, { logoutUser, showMessage, handleAppError })(
    ITQNotifications
  )
);
